import { render } from "./createDetail.vue?vue&type=template&id=5037af56&scoped=true"
import script from "./createDetail.vue?vue&type=script&lang=ts"
export * from "./createDetail.vue?vue&type=script&lang=ts"

import "./createDetail.vue?vue&type=style&index=0&id=5037af56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5037af56"

export default script